import app from 'flarum/forum/app';
import on from './gate';
import Stream from 'flarum/common/utils/Stream';
export default async function startChallenge(song) {
  if (!on()) return;
  if (!app.session.user) {
    app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal'));
    return;
  }
  await app.tagList.load(['parent']);
  const tag = app.store.all('tags').find(t => t.slug() === 'challenges');
  await app.composer.load(() => flarum.reg.asyncModuleImport('flarum/forum/components/DiscussionComposer'), {
    user: app.session.user
  });
  app.composer.fields.tags = tag ? [tag] : [];
  if (song) {
    app.composer.fields.title = Stream(`30 days: ${song.track} (${song.artist})`.slice(0, 80));
    app.composer.fields.challenge = {
      song,
      parts: ['rhythm'],
      hard_part: null
    };
  }
  await app.composer.show();
  m.redraw();
}